import styled, { css } from "styled-components";

interface IContainerProps {
  $backgroundColor?: string;
  $imagePosition?: boolean;
}

export const HeroFooterImageContainer = styled.div<{ $altStyling?: boolean }>`
  width: 100%;
  background: linear-gradient(
    to bottom,
    ${({ theme, $altStyling }) =>
      $altStyling
        ? css`
            ${theme.colors.primary[950]} 30%
          `
        : css`
            ${({ theme }) => theme.colors.base} 30%
          `},
    ${({ theme, $altStyling }) =>
      $altStyling
        ? css`
            ${({ theme }) => theme.colors.base} 0%
          `
        : css`
            ${theme.colors.default[50]} 0%
          `}
  );
  padding-bottom: ${({ $altStyling }) => ($altStyling ? "0" : "96px")};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;

export const Container = styled.div<IContainerProps>`
  background-color: ${(props) =>
    props.$backgroundColor === "grey"
      ? props.theme.colors.default[50]
      : props.$backgroundColor === "burgundy"
        ? props.theme.colors.primary[950]
        : props.theme.colors.base};
  color: ${(props) =>
    props.$backgroundColor === "grey"
      ? "#000"
      : props.$backgroundColor === "burgundy"
        ? props.theme.colors.base
        : "#333"};
  border-radius: 24px;
  overflow: hidden;
  display: flex;
  flex-direction: ${(props) => (props.$imagePosition ? "row-reverse" : "row")};
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  z-index: 5;

  @media (max-width: 768px) {
    flex-direction: column;
    border-radius: 12px;
  }
`;

export const ImageWrapper = styled.div`
  flex: 1;
  position: relative;
  min-width: 650px;
  min-height: 576px; /* Adjust as needed */

  @media (max-width: 768px) {
    min-height: 290px;
    min-width: 100%;

    img {
      width: 100%;
      height: 100%;
    }
  }
`;

export const TextWrapper = styled.div`
  flex: 1;
  gap: 24px;
  padding: 0 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 20px;
    gap: 12px;
  }
`;

export const Title = styled.h2<{ textColor?: string }>`
  font-size: 39px;
  letter-spacing: 3%;
  font-weight: 700;
  color: ${(props) => props.textColor || "inherit"};
`;

export const BulletList = styled.ul`
  list-style: none;
  padding: 0;
  display: flex;
  gap: 12px;
  flex-direction: column;
  max-width: 304px;
`;

export const BulletItem = styled.li`
  display: flex;
  /* Change 'center' to 'flex-start' so the icon stays at the top */
  align-items: center;
  gap: 12px;

  svg {
    width: 35px !important;
    height: 35px !important;
    flex-shrink: 0;
  }
`;

export const BulletText = styled.p`
  font-size: 17px;
  line-height: 150%;
  font-weight: 550;
  margin: 0; /* Ensure no default paragraph margins are pushing the text down */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
